import { ETheme } from "../../";
import { IColumnDl, IFilterQuery } from "@/DependenciesV9/DataTable/Model.ts";

export interface IFilterProps {
  theme?: ETheme;
  columns?: IColumnDl[];
}

export interface IRefFilter {
  onOpenFilter?: (filters: IFilterQuery[]) => void;
}

export enum ETypeColumn {
  STRING = "string",
  NUMBER = "number",
  BOOLEAN = "boolean",
  DATE = "date",
  BOOLEAN_STRING = "boolean|string",
  BOOLEAN_MULTIPLE = "boolean|multiple",
}

export enum OperatorFilterStringEnums {
  Equal = "eq",
  NotEqual = "ne",
  NotContain = "not",
  Contain = "contains",
  Null = "null",
}

export enum OperatorFilterNumberEnums {
  Equal = "eq",
  Less = "lt",
  Greater = "gt",
  LessOrEqual = "le",
  GreaterOrEqual = "ge",
  Null = "null",
}